<script lang="ts">
      import type { EditorNode, Transformer, TransformerFunction } from '$lib/lexical/parser/index.ts'

      function formats() {
            const map = new Map()
            map.set(1, 'IS_BOLD')
            map.set(1 << 1, 'IS_ITALIC')
            map.set(1 << 2, 'IS_STRIKETHROUGH')
            map.set(1 << 3, 'IS_UNDERLINE')
            map.set(1 << 4, 'IS_CODE')
            map.set(1 << 5, 'IS_SUBSCRIPT')
            map.set(1 << 6, 'IS_SUPERSCRIPT')
            map.set(1 << 7, 'IS_HIGHLIGHT')

            return map
      }

      function getFormats(textFormat: number) {
            const formatMap = formats()
            const results: string[] = []
            formatMap.forEach((format, mask) => {
                  if (textFormat & mask) results.push(format)
            })

            return results
      }

      function formatToHtml(format: string) {
            switch (format) {
                  case 'IS_BOLD':
                        return (input: string) => `<span class="lexical-bold">${input}</span>`
                  case 'IS_ITALIC':
                        return (input: string) => `<span class="lexical-italic">${input}</span>`
                  case 'IS_STRIKETHROUGH':
                        return (input: string) => `<span class="lexical-strike">${input}</span>`
                  case 'IS_UNDERLINE':
                        return (input: string) => `<span class="lexical-underline">${input}</span>`
                  case 'IS_CODE':
                        return (input: string) => `<span class="lexical-code">${input}</span>`
                  case 'IS_SUBSCRIPT':
                        return (input: string) => `<span class="lexical-sub">${input}</span>`
                  case 'IS_SUPERSCRIPT':
                        return (input: string) => `<span class="lexical-super">${input}</span>`
                  case 'IS_HIGHLIGHT':
                        return (input: string) => `<span class="lexical-highlight">${input}</span>`
                  default:
                        return (input: string) => `${input}`
            }
      }

      interface TextNode extends EditorNode {
            text: string
            format: number
      }

      function TEXT_NODE(node: TextNode) {
            const { format, text } = node
            let formats = getFormats(format)

            let string =
                  formats.length > 0
                        ? formats.reduce((previous, current) => {
                                return formatToHtml(current)(previous)
                          }, text)
                        : text

            return `${string}`
      }

    let { node, children = undefined } = $props()
</script>

{@html TEXT_NODE(node)}